import React from 'react';

import { Box } from '@vp/swan';

interface TriggerLinkProps {
  onTriggerOnClick: () => void;
  trigger: React.ReactNode;
}

export const TriggerLink: React.FC<TriggerLinkProps> = (props) => {
  return <Box onClick={props.onTriggerOnClick}>{props.trigger}</Box>;
};
